module.exports = __webpack_public_path__ + "img/hnd.9b9bee13.svg";